/**
 * Ratio du serveur : `value` est un pourcentage déjà arrondi (contrat §1). Le
 * front l'affiche tel quel et ne divise jamais `num` par `den`.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { Ratio } from '../../../api/monitoring/v2';
import { decimalsOf, useFormat } from './format';

export const RatioText: React.FC<{ ratio: Ratio; showFraction?: boolean }> = ({ ratio, showFraction }) => {
    const { t } = useTranslation();
    const f = useFormat();
    const fraction = t('monitoring.ratio.fraction', { num: f.count(ratio.num), den: f.count(ratio.den) });
    if (ratio.value === null) {
        return (
            <span title={fraction} aria-label={t('monitoring.ratio.undefined')}>
                —
            </span>
        );
    }
    return (
        <span title={fraction}>
            <span dir="ltr" style={{ unicodeBidi: 'isolate' }}>
                {t('monitoring.ratio.percent', { value: f.decimal(ratio.value, decimalsOf(ratio.value)) })}
            </span>
            {showFraction && <span style={{ marginInlineStart: 6, fontSize: '0.85em' }}>({fraction})</span>}
        </span>
    );
};

export default RatioText;
